// extracted by mini-css-extract-plugin
export var contrastLow = "_2e-1";
export var externalLink = "_2e-2";
export var externalLinkIcon = "_2e-3";
export var link = "_2e-0";
export var linkLabel = "_2e-4";